export default __webpack_public_path__ + "static/media/00.722c5cba.jpg";